module.exports = __webpack_public_path__ + "static/img/celoscope-19.263d022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-19.jpg
// module id = qqoy
// module chunks = 51